import { Component, OnInit, Output, EventEmitter, Inject, Self } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatRadioChange } from '@angular/material/radio';
import { Utils } from '../../../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { DefaultValuesService } from '../../../../../../services/defaultvalues.service';
import { DestroyService } from '../../../../../../services/destroyservice';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'mandatory-version-peripheral-compatibility-groups',
  templateUrl: './mandatory-version-peripheral-compatibility-groups.component.html',
  styleUrls: ['mandatory-version-peripheral-compatibility-groups.component.less'],
  providers: [DestroyService],
  standalone: false
})
export class CompatibilityGroupsSelectionComponent implements OnInit{

    @Output()
  public controllerGroupSelectedTrigger = new EventEmitter<EMTGlobalControllerGroup>();
  private subscriptionStage: any;

  // Full list of groups 
  public allCompatibilityGroups: EMTGlobalControllerGroup[] = [];
  // Filtered list shown in the UI
  public filteredGroups: EMTGlobalControllerGroup[] = [];
  // Selected group ID
  public selectedCompatibilityGroup: EMTGlobalControllerGroup | undefined;
  // Search input
  public searchString: string = '';

  constructor(
        private readonly http: HttpClient,
        @Inject('BASE_URL') private readonly baseUrl: string,
        public defaults: DefaultValuesService,
        private readonly toastrService: ToastrService,
        @Self() private readonly destroy$: DestroyService) {
    }

  public ngOnInit() {
    this.subscriptionStage = this.defaults.stageMessageChanges$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.loadControllerGroups();
        });
    this.loadControllerGroups();
  }
  
  loadControllerGroups() {
    Utils.httpGetEMTGlobalControllerGroups(
            this.http,
            this.baseUrl,
            this,
            (tthis: CompatibilityGroupsSelectionComponent, result: EMTGlobalControllerGroup[]) => {
                tthis.allCompatibilityGroups = result;
                tthis.filteredGroups = tthis.allCompatibilityGroups;
            }
        );
  }

  // Filter logic triggered on keyup
  filterGroups(search: string): void {
    const lowerSearch = search.toLowerCase();
    this.filteredGroups = this.allCompatibilityGroups.filter(group =>
      group.globalControllerGroupName.toLowerCase().includes(lowerSearch)
    );
  }

  // Handle selection change
  onSelectionChange(event: MatRadioChange): void {
    const selectedGroup = this.allCompatibilityGroups.find(g => g.globalControllerGroupId === event.value.globalControllerGroupId);
    if(selectedGroup) {
      this.controllerGroupSelectedTrigger.emit(selectedGroup)
    }
  }
}